const { connect } = require('react-redux');
const tipsComponent = require('../component/tipsComponent').default;
const { actions: { modalDisable } } = require('../../../../reducers').default;
const { modalType } = require('../../../../define/screenType').default;
// ======================

const mapStateToProps = (state) => {
    return {
        isModalOpen: state.screenState.modal === modalType.MODAL_TIPS,
        soundEnable: state.appState.soundEnable
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleBackClick: () => {
            dispatch(modalDisable());
        }
    };
};

export const TipsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(tipsComponent);